import { type RankingInfo, rankItem } from "@tanstack/match-sorter-utils";
import {
	columnFilteringFeature,
	columnOrderingFeature,
	columnResizingFeature,
	columnSizingFeature,
	columnVisibilityFeature,
	constructFilterFn,
	createFilteredRowModel,
	createPaginatedRowModel,
	createSortedRowModel,
	filterFn_includesString,
	globalFilteringFeature,
	rowPaginationFeature,
	rowSelectionFeature,
	rowSortingFeature,
	tableFeatures,
} from "@tanstack/react-table";

/**
 * Fuzzy filter used by app tables (match-sorter ranking + filter meta).
 */
export const fuzzyFilter = constructFilterFn({
	filter: (dataValue, filterValue, _row, _columnId, addMeta) => {
		const itemRank = rankItem(dataValue, filterValue);
		addMeta?.({ itemRank });
		return itemRank.passed;
	},
	autoRemove: (filterValue) => !filterValue,
});

/**
 * Shared TanStack Table v9 features for Fawkes app tables.
 * Keep module-static — do not recreate inside render.
 */
export const appTableFeatures = tableFeatures({
	columnFilteringFeature,
	filteredRowModel: createFilteredRowModel(),
	filterFns: {
		fuzzy: fuzzyFilter,
		includesString: filterFn_includesString,
	},
	filterMeta: {} as { itemRank?: RankingInfo },
	globalFilteringFeature,
	rowSortingFeature,
	sortedRowModel: createSortedRowModel(),
	rowPaginationFeature,
	paginatedRowModel: createPaginatedRowModel(),
	columnOrderingFeature,
	columnVisibilityFeature,
	columnSizingFeature,
	columnResizingFeature,
	rowSelectionFeature,
});

export type AppTableFeatures = typeof appTableFeatures;

/** Stable empty data fallback so tables do not get a new `[]` every render. */
export const EMPTY_TABLE_DATA: never[] = [];
